<aur-mat-table
  [tableConfig]="tableConfig"
  [pageSource]="loadPage">
</aur-mat-table>
